class OrderManagementCountdownController {
    constructor($interval, $scope, orderManagementService) {
        this.orderManagementService = orderManagementService;

        const intervalPromise = $interval(() => {
            this.setTimeRemaining();
        }, 5000);

        $scope.$on('$destroy', () => {
            $interval.cancel(intervalPromise);
        });
    }

    $onInit() {
        this.finalDate = new Date(Date.now() + Math.floor(parseFloat(this.minutesLeft) * 60000));
        this.setTimeRemaining();
    }

    setTimeRemaining() {
        let msec = this.finalDate.getTime() - Date.now();

        if (msec <= 0) {
            this.orderManagementService.invalidate();
            this.orderManagementService.getOrders();
        }

        const hours = Math.floor(msec / 1000 / 60 / 60);
        msec -= hours * 1000 * 60 * 60;
        const mins = Math.floor(msec / 1000 / 60);

        const hh = hours < 10 ? `0${hours}` : hours;
        const mm = mins < 10 ? `0${mins}` : mins;

        this.hours = `${hh}`;
        this.mins = `${mm}`;
        this.srTimeString = `${hours} hours and ${mins} minutes `;
    }

}

const orderManagementCountdownComponentDefinition = {
    bindings: {
        minutesLeft: '=',
    },
    controller: ['$interval', '$scope', 'OrderManagementService', OrderManagementCountdownController],
    template: '<span aria-hidden="true">{{$ctrl.hours}}<span class="orderManagementItem-timerUnit">h</span>{{$ctrl.mins}}<span class="orderManagementItem-timerUnit">m</span></span><span class="sr-only">{{$ctrl.srTimeString}}</span>',
};

module.exports = {
    OrderManagementCountdownController,
    orderManagementCountdownComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/order/ordermanagement/order-management-countdown.component.js